import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15",
  fill: "none",
  viewBox: "0 0 14 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#696969",
      "fill-rule": "evenodd",
      d: "M7.512 1.365a.83.83 0 0 0-1.024 0l-4.666 3.63a.83.83 0 0 0-.322.657v6.681a.833.833 0 0 0 .833.833h9.334a.833.833 0 0 0 .833-.833V5.652c0-.257-.119-.5-.322-.658zM5.874.575a1.83 1.83 0 0 1 2.252 0l4.666 3.63c.447.347.708.881.708 1.447v6.681a1.833 1.833 0 0 1-1.833 1.833H2.333A1.833 1.833 0 0 1 .5 12.333V5.652c0-.566.261-1.1.708-1.447z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#696969",
      "fill-rule": "evenodd",
      d: "M4.5 8.333a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v5.333a.5.5 0 0 1-1 0V8.833h-3v4.833a.5.5 0 0 1-1 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }